import { render, staticRenderFns } from "./changeCustomerBillingGroup.vue?vue&type=template&id=b81f0530"
import script from "./changeCustomerBillingGroup.ts?vue&type=script&lang=js&external"
export * from "./changeCustomerBillingGroup.ts?vue&type=script&lang=js&external"
import style0 from "./changeCustomerBillingGroup.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports